import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, unref as _unref, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "panel" }

import { computed, onBeforeMount } from 'vue';
import { useGettext } from '@jshmrtn/vue3-gettext';
import { useStore } from 'vuex';
import { AppStore } from '@/store';
import { LinkBuilder } from '@/core/common';
import { getValueInUserLanguage } from '@/core/languageContent';
import { dateTime } from '@/core/date';
import { TicketStub, useTicket } from '@/modules/ticket/Ticket';
import ResourceTable from '@/core/components/resource/ResourceTable.vue';
import Column from '@/core/components/resource/Column';
import { TicketStatus } from '@/modules/ticket_status/TicketStatus';
import { TicketCategory } from '@/modules/ticket_category/TicketCategory';


export default /*@__PURE__*/_defineComponent({
  __name: 'DashboardTicketsList',
  setup(__props) {

const { $gettext } = useGettext();
const resource = useTicket();
const store = useStore<AppStore>();
const ticketStatusOptions = computed<TicketStatus[]>(() => store.getters.ticketStatuses);
const ticketCategoryOptions = computed<TicketCategory[]>(() => store.getters.ticketCategories);

onBeforeMount(async () => {
	await store.dispatch('loadTicketStatuses');
	await store.dispatch('loadTicketCategories');
});

const getStatusName = (t: TicketStub) => {
	const option = ticketStatusOptions.value.find(ts => ts.id === t.status?.id)?.content;
	if (!option) {
		return '-';
	}

	return getValueInUserLanguage(option) || '';
};

const getCategoryName = (t: TicketStub) => {
	const option = ticketCategoryOptions.value.find(tc => tc.id === t.category?.id)?.content;
	if (!option) {
		return '-';
	}

	return getValueInUserLanguage(option) || '';
};

const columns = [
	new Column<TicketStub>($gettext('Skapad'), 'created_time', 't.created_time')
		.withFormatter(t => dateTime(t.created_time)),
	new Column<TicketStub>($gettext('Ärende'), 'id', 'i.id', '+'),
	new Column<TicketStub>($gettext('Status'), 'status')
		.withFormatter(getStatusName),
	new Column<TicketStub>($gettext('Kategori'), 'category')
		.withFormatter(getCategoryName),
];

if (store.state.authenticatedUser?.law_firm) {
	columns.push(
		new Column<TicketStub>($gettext('Kund'), 'customer')
			.withFormatter(t => t.customer?.name || '-'),
	);
}

const rowLink: LinkBuilder<TicketStub> = (t: TicketStub) => ({
	name: 'ticket.view',
	params: { id: t.id },
});

return (_ctx: any,_cache: any) => {
  const _directive_translate = _resolveDirective("translate")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _withDirectives((_openBlock(), _createElementBlock("h2", null, [...(_cache[0] || (_cache[0] = [
      _createTextVNode("Senaste ärenden", -1)
    ]))])), [
      [_directive_translate]
    ]),
    _createVNode(ResourceTable, {
      columns: columns,
      resource: _unref(resource),
      sortable: false,
      showFilters: false,
      "row-link": rowLink,
      allowDelete: false
    }, null, 8, ["resource"])
  ]))
}
}

})